import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import axios from "axios";
import ReactPaginate from "react-paginate";

export default function Loan_list() {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  /* ✅ SORT STATE */
  const [sortConfig, setSortConfig] = useState({
    key: "",
    direction: "asc",
  });

  /* ---------------- FETCH DATA ---------------- */
  const getLoanData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/loan-application`
      );
      if (res.status === 200) {
        setData(res.data.data);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error(err);
      setLoader(true);
    }
  };

  useEffect(() => {
    getLoanData();
  }, []);

  /* ---------------- SEARCH ---------------- */
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(0);
  };

  const filterDataBySearch = (items) => {
    return items.filter((item) => {
      const q = searchQuery.toLowerCase();
      return (
        item.user_first_name?.toLowerCase().includes(q) ||
        item.user_last_name?.toLowerCase().includes(q) ||
        item.user_email?.toLowerCase().includes(q) ||
        item.loan_category?.toLowerCase().includes(q) ||
        item.loan_type?.toLowerCase().includes(q) ||
        item.application_code?.toLowerCase().includes(q)
      );
    });
  };

  /* ---------------- SORT FUNCTION ---------------- */
  const handleSort = (key) => {
    let direction = "asc";

    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    setSortConfig({ key, direction });

    const sorted = [...filteredData].sort((a, b) => {
      const A = (a[key] || "").toString().toLowerCase();
      const B = (b[key] || "").toString().toLowerCase();

      if (A < B) return direction === "asc" ? -1 : 1;
      if (A > B) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setFilteredData(sorted);
  };

  /* ---------------- APPLY SEARCH + SORT ---------------- */
  useEffect(() => {
    let temp = filterDataBySearch(data);

    if (sortConfig.key) {
      temp = [...temp].sort((a, b) => {
        const A = (a[sortConfig.key] || "").toString().toLowerCase();
        const B = (b[sortConfig.key] || "").toString().toLowerCase();

        if (A < B) return sortConfig.direction === "asc" ? -1 : 1;
        if (A > B) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
      });
    }

    setFilteredData(temp);
  }, [data, searchQuery, sortConfig]);

  /* ---------------- PAGINATION ---------------- */
  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(0);
  };

  /* ---------------- UI ---------------- */
  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header Section with Card Shadow */}
          <div
            className="mb-4"
            style={{
              background: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              padding: "20px",
            }}
          >
            <div className="content-page-header">
              <h5>Loan Applications</h5>
            </div>
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Loan Applications
                </li>
              </ol>
            </nav>

          </div>

          {/* Search Filter Section with Card Shadow */}
          <div
            className="mb-4"
            style={{
              background: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              padding: "20px",
            }}
          >
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="form-group">
                  <input
                    id="search"
                    className="form-control"
                    type="text"
                    placeholder="Search by name, email, application code, loan category or type..."
                    aria-label="Search Input"
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Table Section with Card Shadow */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              padding: "20px",
            }}
          >
            <div className="table-responsive">
              <table className="table datatable">
                <thead>
                  <tr>
                    <th>Index</th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSort("application_code")}
                    >
                      Application Code{" "}
                      {sortConfig.key === "application_code" &&
                        (sortConfig.direction === "asc" ? "▲" : "▼")}
                    </th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSort("user_first_name")}
                    >
                      Name{" "}
                      {sortConfig.key === "user_first_name" &&
                        (sortConfig.direction === "asc" ? "▲" : "▼")}
                    </th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>PAN</th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSort("loan_category")}
                    >
                      Loan Category{" "}
                      {sortConfig.key === "loan_category" &&
                        (sortConfig.direction === "asc" ? "▲" : "▼")}
                    </th>
                    <th
                      style={{ cursor: "pointer" }}
                      onClick={() => handleSort("loan_type")}
                    >
                      Loan Type{" "}
                      {sortConfig.key === "loan_type" &&
                        (sortConfig.direction === "asc" ? "▲" : "▼")}
                    </th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.length === 0 ? (
                    <tr>
                      <td colSpan="9" className="text-center" style={{ padding: "40px" }}>
                        No data available
                      </td>
                    </tr>
                  ) : (
                    currentItems.map((item, index) => (
                      <tr key={item.id}>
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>{item.application_code || "-"}</td>
                        <td>
                          {item.user_first_name} {item.user_last_name}
                        </td>
                        <td>{item.user_email || "-"}</td>
                        <td>
                          {item.country_code} {item.user_phone}
                        </td>
                        <td>{item.user_pan || "-"}</td>
                        <td>{item.loan_category || "-"}</td>
                        <td>{item.loan_type || "-"}</td>
                        <td>
                          <div className="table-actions d-flex justify-content-center">
                            <Link
                              to={`/loan-application-view/${item.id}`}
                              className="btn btn-sm btn-primary"
                              title="View Details"
                            >
                              <i className="fas fa-eye"></i>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {pageCount > 1 && (
              <div className="d-flex justify-content-between align-items-center mt-4">
                <div className="d-flex align-items-center gap-2">
                  <label style={{ margin: 0, marginRight: "10px" }}>Show:</label>
                  <select
                    className="form-select"
                    style={{ width: "80px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                  </select>
                  <span style={{ marginLeft: "10px", color: "#666" }}>
                    entries
                  </span>
                </div>
                <ReactPaginate
                  previousLabel="Previous"
                  nextLabel="Next"
                  pageCount={pageCount}
                  onPageChange={handlePageClick}
                  containerClassName="pagination"
                  pageLinkClassName="page-link"
                  previousLinkClassName="page-link"
                  nextLinkClassName="page-link"
                  activeClassName="active"
                  forcePage={currentPage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
